import { render, staticRenderFns } from "./request_a_demo.vue?vue&type=template&id=48355132&scoped=true&"
import script from "./request_a_demo.vue?vue&type=script&lang=js&"
export * from "./request_a_demo.vue?vue&type=script&lang=js&"
import style0 from "./request_a_demo.vue?vue&type=style&index=0&id=48355132&lang=scss&scoped=true&"
import style1 from "./request_a_demo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48355132",
  null
  
)

export default component.exports